import React, { Component } from 'react';

import moment from 'moment';

import Checkbox from 'material-ui/Checkbox';
import Divider from 'material-ui/Divider';
import { List, ListItem } from 'material-ui/List';
import History from 'material-ui/svg-icons/action/history';
import Schedule from 'material-ui/svg-icons/action/schedule';

import MarkerText from '../../../components/MarkerText';

import '../styles/planner.css';

function PlannerAssignmentListHeader(props) {
  const { date, period } = props;
  

  const startOfPeriod = moment(date).startOf(period);
  const endOfPeriod = moment(date).endOf(period);

  const headerDateFormat = 'ddd, M/D/YY';

  return (
    <div className="list-content__header">
      <p className="planner-list__header__subheadline">
        Planned Assignments
      </p>
      <p className="planner-list__header__headline">
        {startOfPeriod.format(headerDateFormat)} - {endOfPeriod.format(headerDateFormat)}
      </p>
    </div>
  ); 
}

function PlannerAssignmentListItem(props) {
  const { onItemSelected, item } = props;

  const plannedAtIconStyles = {
    marginRight: '2px',
    marginBottom: '-3px',
    height: '14px',
    width: '14px',
    color: '#969696',
  };

  const dueAtIconStyles = {
    marginRight: '4px',
    marginBottom: '-3px',
    height: '13px',
    width: '13px',
    color: '#666666',
  }

  return (
    <div key={item.id}>
      <ListItem 
        value={item.id}
        onClick={() => onItemSelected(item)}
        innerDivStyle={{padding: '6px'}} >
                
        <p className='planner-list__item__header'>
          <span>
            { <History style={plannedAtIconStyles} />}
          </span>
          {moment(item.get('plannedAt')).format('ddd M/D')}
        </p>
        
        <div className="planner-list__item__title">
          <Checkbox
            checked={item.get('completed')}
            disabled={true}
            style={{width: 'auto'}} />
          
            <p>
              {item.get('title')}
            </p>
          
        </div>
          
        <div className='planner-list__item__detail--left'>
          <p className="list-content__list__item__detail-title">
            <span>
              <Schedule style={dueAtIconStyles} />
            </span>
            {moment(item.get('dueAt')).format('ddd M/D')}
          </p>
          {item.get('course') != null ? (
            <MarkerText 
              className='list-content__list__item__detail-subtitle' 
              markerStyle={{height: '6px', width: '6px', marginBottom: '2px', marginRight: '4px'}}
              text={item.get('course').get('title')} 
              color={item.get('course').get('color')} />
            ) : null}
        </div>          
        <Divider />
      </ListItem>
    </div>
  );
}

class PlannerAssignmentList extends Component {

  constructor(props) {
    super(props);

    this.state = {
      selectedItem: null,
    };
  }


  handleItemSelected = (item) => {
    this.setState({selectedItem: item});
  }

  render() {
    const items = this.props.items || [];

    return (
      <div className='detail-container detail-container-smaller detail-container-inset darker-background'>

        <div className='list-content'>
          <PlannerAssignmentListHeader 
            date={this.props.date}
            period={this.props.period} />

          <div className='list-content__list'>
            <List>
              {items.map((item) =>
                <PlannerAssignmentListItem 
                  item={item} 
                  onItemSelected={this.props.onItemSelected} />
              )}
            </List>
          </div>
        </div>
      </div>
    );
  }

}

export default PlannerAssignmentList;


// WEBPACK FOOTER //
// ./src/scenes/Planner/components/PlannerAssignmentList.js